import React, { useState, useEffect } from "react";
import axios from "axios";
import "./WINAchievementsDetails.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import RedeemRewardsModal from "../WINCentive/RedeemRewardsModal";
import { Endpoints } from "../../Global/Endpoints";

import badgeImage1 from "../../assets/images/badges/01-01.png"
import badgeImage1gray from "../../assets/images/badges/01-01-gray.png"
import badgeImage2 from "../../assets/images/badges/01-02.png"
import badgeImage2gray from "../../assets/images/badges/01-02-gray.png"
import badgeImage3 from "../../assets/images/badges/01-03.png"
import badgeImage3gray from "../../assets/images/badges/01-03-gray.png"
import badgeImage4 from "../../assets/images/badges/01-04.png"
import badgeImage4gray from "../../assets/images/badges/01-04-gray.png"
import badgeImage5 from "../../assets/images/badges/01-05.png"
import badgeImage5gray from "../../assets/images/badges/01-05-gray.png"
import badgeImage6 from "../../assets/images/badges/01-06.png"
import badgeImage6gray from "../../assets/images/badges/01-06-gray.png"
import badgeImage7 from "../../assets/images/badges/01-07.png"
import badgeImage7gray from "../../assets/images/badges/01-07-gray.png"
import badgeImage8 from "../../assets/images/badges/02-01.png"
import badgeImage8gray from "../../assets/images/badges/02-01-gray.png"
import badgeImage9 from "../../assets/images/badges/02-02.png"
import badgeImage9gray from "../../assets/images/badges/02-02-gray.png"
import badgeImage10 from "../../assets/images/badges/02-03.png"
import badgeImage10gray from "../../assets/images/badges/02-03-gray.png"
import badgeImage11 from "../../assets/images/badges/02-04.png"
import badgeImage11gray from "../../assets/images/badges/02-04-gray.png"
import badgeImage12 from "../../assets/images/badges/02-05.png"
import badgeImage12gray from "../../assets/images/badges/02-05-gray.png"
import badgeImage13 from "../../assets/images/badges/02-06.png"
import badgeImage13gray from "../../assets/images/badges/02-06-gray.png"
import badgeImage14 from "../../assets/images/badges/02-07.png"
import badgeImage14gray from "../../assets/images/badges/02-07-gray.png"
import badgeImage15 from "../../assets/images/badges/03-01.png"
import badgeImage15gray from "../../assets/images/badges/03-01-gray.png"
import badgeImage16 from "../../assets/images/badges/03-02.png"
import badgeImage16gray from "../../assets/images/badges/03-02-gray.png"
import badgeImage17 from "../../assets/images/badges/03-03.png"
import badgeImage17gray from "../../assets/images/badges/03-03-gray.png"
import badgeImage18 from "../../assets/images/badges/03-04.png"
import badgeImage18gray from "../../assets/images/badges/03-04-gray.png"
import badgeImage19 from "../../assets/images/badges/04-01.png"
import badgeImage19gray from "../../assets/images/badges/03-05-gray.png"

const WINAchievementsDetails = () => {
  const navigate = useNavigate();
  const [badgeIds, setBadgeIds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [email, setEmail] = useState(""); // User's email
  const token = localStorage.getItem("AccessToken") || "YOUR_ACCESS_TOKEN_HERE";
  const { t } = useTranslation();
  const userData = useSelector((state) => state.userData);
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal visibility state
  const [amount, setAmount] = useState(""); // Redemption amount (no default value)
  const contractData = useSelector((state) => state.userData);
  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";

  
  const ranges = {
    dailyGoals: [1, 2, 3, 4, 5, 6, 7], // 1–7
    weeklyGoals: [8, 9, 10, 11, 12, 13, 14], // 8–14
    bonusGoals: [15, 16, 17, 18, 19], // 15–19
    specialgoals:[20]
  };

  const badgeImageURLs = {
    1: badgeImage1,
    2: badgeImage2,
    3: badgeImage3,
    4: badgeImage4,
    5: badgeImage5,
    6: badgeImage6,
    7: badgeImage7,
    8: badgeImage8,
    9: badgeImage9,
    10:badgeImage10,
    11: badgeImage11,
    12: badgeImage12,
    13: badgeImage13,
    14: badgeImage14,
    15: badgeImage15,
    16: badgeImage16,
    17: badgeImage17,
    18: badgeImage18,
    19: badgeImage19,
    
  };

  const badgeImageURLgray= {
    1: badgeImage1gray,
    2: badgeImage2gray,
    3: badgeImage3gray,
    4: badgeImage4gray,
    5: badgeImage5gray,
    6: badgeImage6gray,
    7: badgeImage7gray,
    8: badgeImage8gray,
    9: badgeImage9gray,
    10: badgeImage10gray,
    11: badgeImage11gray,
    12: badgeImage12gray,
    13: badgeImage13gray,
    14: badgeImage14gray,
    15: badgeImage15gray,
    16: badgeImage16gray,
    17: badgeImage17gray,
    18: badgeImage18gray,
    19: badgeImage19gray,
  };

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  useEffect(() => {
    const deviceType = isHighmarkPortal ? "HighmarkPortal" : "PatientPortal";
    const fetchAchievements = async () => {
      setLoading(true);
      try {
        const response = await axios.post(
          Endpoints.GetWINAchievementsDetails,
          `_Params=${encodeURIComponent(
            JSON.stringify({
              MemberID: contractData.userData.MemberID,
              Contract: contractData.userData.ContractIdentified,
              DeviceType: deviceType,
              EmailID: contractData.userData.EmailID,
            })
          )}`,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const badgeIdsArray = response.data?.split(",").map(Number).filter(Boolean);
        setBadgeIds(badgeIdsArray);
      } catch (err) {
        setError(t("failedtofetchachievement"));
      } finally {
        setLoading(false);
      }
    };

    fetchAchievements();
  }, [contractData, token, t]);

  const renderBadges = (ids) =>
    ids.map((id) => (
      <div key={id} className="badge-wrapper">
        <img
          src={badgeIds.includes(id) ? badgeImageURLs[id] : badgeImageURLgray[id]}
          alt={`Badge ${id}`}
          className="wincentive-badge"
        />
      </div>
    ));

  if (loading){
    return (
      <div className="loading-container">
        <div className="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }
  if (error) return <div>{error}</div>;

  const handleRewardHistoryClick = () => {
    navigate("/incentive-rewardshistory");
  };

  const handleAchievementsClick = () => {
    navigate("/incentive-achievementdetails");
  };

  const handleMyWinCardClick = () => {
    navigate("/pay-cards");
  };
  const handleBackClick = () => {
    navigate(-1);
  };
  const renderSpecialBadge = () => {
    if (badgeIds.includes(20)) {
      return (
        <div className="special-badge-wrapper">
          <img src={badgeImage19} alt="Special Bonus Badge" className="wincentive-badge special-badge" />
        </div>
      );
    }
    return null; // Do not render anything if badge ID 20 is not present
  };
return (
    <>
    
      <div className="col-md-12 col-lg-6 mt-4 d-flex inner-page-heading-wrapper">
        <button className="win-back-btn me-3" onClick={handleBackClick}>
          <span>
            <i className="bi bi-chevron-left"></i> {t("back")}
          </span>
        </button>
        <h2 className="page-heading">{t("myachievements")}</h2>
      </div>
      
      <div className="col-md-12 col-lg-6 mt-4 d-flex justify-content-end flex-sm-column flex-md-row flex-wrap align-items-center gap-1">
        <button className="win-btn-with-icon reward-history-btn" onClick={handleRewardHistoryClick}>
          {t("REWARD HISTORY")}
        </button>
        <button className="win-btn-with-icon achievements-btn ms-3" onClick={handleAchievementsClick}>
          {t("ACHIEVEMENTS")}
        </button>
        <button className="win-btn-with-icon mywincard-btn ms-3" onClick={handleMyWinCardClick}>
          {t("MY WINCARD")}
        </button>
      </div>
      <div className="achievements-notes-wrapper">
        {badgeIds.length === 0 ? (
          <p className="achievements-notes-no-badges">
            Your WIN badge collection is empty—for now.
            <br />
            <span>Time to start earning!</span>
          </p>
        ) : (
          <p className="achievements-notes-some-badges">
            Your little one isn't the only one reaching major milestones.
            <br />
            <span>You're crushing your goals and achieving your own—just look at these WIN badges. Way to go!</span>
          </p>
        )}
      </div>
      <div className="badges-section">
        <div className="goals-heading-wrapper">
          <h4 className="goals-heading">
            {t("daily")} <span>{t("goal")}</span>
          </h4>
        </div>
        <div className="badges-grid">{renderBadges(ranges.dailyGoals)}</div>
      </div>

      <div className="badges-section">
        <div className="goals-heading-wrapper">
          <h4 className="goals-heading">
            {t("weekly")} <span>{t("goals")}</span>
          </h4>
        </div>
        <div className="badges-grid">{renderBadges(ranges.weeklyGoals)}</div>
      </div>

      <div className="badges-section">
        <div className="goals-heading-wrapper">
          <h4 className="goals-heading">
            {t("bonus")} <span>{t("goals")}</span>
          </h4>
        </div>
        <div className="badges-grid">{renderBadges(ranges.bonusGoals)}</div>
        <div className="special-badge-section">{renderSpecialBadge(ranges.specialgoals)}</div>
      </div>

      <RedeemRewardsModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        email={contractData.userData.EmailID}
        setAmount={setAmount}
      />
    </>
  );
};

export default WINAchievementsDetails;
